import {createSvgIcon} from './utils'

export default createSvgIcon(
  <>
    <g clipPath="url(#clip0_337_32)">
      <path
        d="M16.3645 7.0925C16.3645 7.0925 16.8153 6.1417 15.8009 5.22312C15.1407 4.64297 14.6255 2.7897 14.7382 2.45128C14.8509 2.11286 14.6899 1.66163 14.5128 2.38682C14.3517 2.9992 14.6255 4.30455 15.3501 5.12643C15.8009 5.64212 16.2195 5.98054 16.1068 6.83466L16.3645 7.0925Z"
        fill="black"
      />
      <path
        d="M16.139 7.86602C16.139 7.86602 13.917 5.69045 11.5178 7.96271C11.5178 7.96271 13.7882 9.13913 12.8543 11.1536L16.139 7.86602Z"
        fill="#331A0F"
      />
      <path
        d="M14.7543 7.06022C14.7543 7.06022 15.4144 6.15776 16.1873 6.88295C16.606 7.28583 16.4127 7.59202 16.4127 7.59202L16.0585 7.94656C16.0585 7.94656 15.5916 7.4631 14.7543 7.06022V7.06022ZM16.8958 7.64037C16.8958 7.64037 17.8458 7.18914 18.7636 8.20441C19.3594 8.86514 21.2111 9.38083 21.5492 9.26802C21.8873 9.15521 22.3382 9.31637 21.6136 9.49364C21.0017 9.65479 19.6975 9.38083 18.8763 8.65564C18.3611 8.20441 18.0229 7.78541 17.1695 7.91433L16.8958 7.64037V7.64037Z"
        fill="black"
      />
      <path
        d="M16.139 7.84985C16.139 7.84985 18.3127 10.0738 16.0424 12.475C16.0424 12.475 14.867 10.2027 12.8542 11.1374L16.139 7.84985V7.84985Z"
        fill="#331A0F"
      />
      <path
        d="M16.928 9.23581C16.928 9.23581 17.8296 8.57508 17.1051 7.80154C16.7025 7.38254 16.3966 7.57593 16.3966 7.57593L16.0424 7.93047C16.0585 7.94658 16.5254 8.41393 16.928 9.23581V9.23581Z"
        fill="black"
      />
      <path
        d="M12.6771 8.22048C12.9187 8.96179 13.6593 9.46136 13.9331 10.0737C14.2068 10.6861 15.2695 11.3146 15.6882 10.8795C16.1068 10.4444 16.4771 8.9779 15.9941 8.4461C15.511 7.91429 17.0085 8.30106 16.767 10.3316C16.5254 12.3621 15.0602 12.8939 15.0602 12.8939C15.0602 12.8939 11.7915 11.0084 11.7432 10.9762C11.711 10.944 10.8093 9.30021 10.8415 9.21964C10.8737 9.13906 11.0992 8.34941 11.0992 8.34941C11.0992 8.34941 12.4356 7.46306 12.6771 8.22048Z"
        fill="#010202"
      />
      <path
        d="M6.52622 12.0076C6.52622 12.0076 4.65842 14.6506 6.94486 16.9067C9.2313 19.1467 12.6771 17.2129 12.6449 17.1162C12.6127 17.0356 6.52622 12.0076 6.52622 12.0076V12.0076ZM12.5805 10.6701C12.5805 10.6701 12.033 9.81595 11.2923 9.62257C11.2923 9.62257 11.0186 9.6548 11.244 9.31637C11.4694 8.97795 12.5805 7.26972 12.194 6.5123C11.8076 5.75488 10.9059 5.17473 10.9542 4.83631C10.9864 4.49788 10.8576 4.35285 10.6805 4.46565C10.4872 4.57846 10.4228 4.70738 10.4228 4.70738C10.4228 4.70738 10.5355 4.11112 10.3101 4.19169C10.0847 4.27227 10.3423 4.75573 10.3423 4.75573C10.3423 4.75573 9.95588 5.25531 10.4228 5.28754C10.8898 5.31977 11.7271 6.01273 11.8237 6.5123C11.9042 7.01188 11.6144 7.80153 11.3728 8.30111C11.1474 8.78457 10.3584 9.46141 11.083 10.0738C11.7915 10.7023 12.516 10.8473 12.516 10.8473L12.5805 10.6701V10.6701Z"
        fill="black"
      />
      <path
        d="M11.3568 9.73542C11.3246 9.73542 11.1797 8.68792 9.87541 8.28503C9.87541 8.28503 9.68219 8.36561 9.40847 8.6718C9.13474 8.97799 8.23304 9.73542 7.8627 9.67095C7.49236 9.60649 6.34914 8.99411 6.34914 8.99411C6.34914 8.99411 5.99491 8.49453 5.83389 8.68792C5.67287 8.8813 5.70508 9.05857 5.70508 9.05857C5.70508 9.05857 4.86779 8.68792 5.04491 9.02634C5.22202 9.36476 5.57626 9.3003 5.57626 9.3003C5.57626 9.3003 5.33474 9.79988 5.67287 9.76765C6.01101 9.7193 6.36524 9.52592 6.60677 9.62261C6.8483 9.7193 7.34745 9.96103 7.65338 10.1061C7.95931 10.2511 8.05592 10.3478 8.28135 10.1222C8.50677 9.89657 9.87541 8.68792 9.87541 8.68792C9.87541 8.68792 9.97202 9.59038 10.6805 9.79988L11.3568 9.73542V9.73542ZM8.95762 11.2019C8.95762 11.2019 7.66948 10.509 6.94491 11.1536C6.22033 11.7982 5.75338 12.8134 5.33474 12.8618C4.91609 12.894 3.86948 12.4428 3.64406 12.6362C3.41863 12.8296 3.48304 13.0391 3.48304 13.0391C3.48304 13.0391 3.19321 12.5395 3.0644 12.8457C2.93558 13.1519 3.01609 13.5709 3.14491 13.4581C3.27372 13.3453 3.48304 13.2324 3.48304 13.2324C3.48304 13.2324 3.59575 13.6676 3.91779 13.4742C4.23982 13.2808 4.46524 13.2808 4.78728 13.2486C5.10931 13.2163 5.65677 13.3291 5.83389 13.0229C5.83389 13.0229 6.79999 11.4759 7.37965 11.5403C7.95931 11.6048 8.12033 12.1849 8.12033 12.1849C8.12033 12.1849 9.13474 11.637 8.95762 11.2019V11.2019Z"
        fill="black"
      />
      <path
        d="M12.9508 10.9601L7.46013 16.4554C7.46013 16.4554 7.1864 16.7133 6.67114 16.1815C6.15589 15.6658 5.2864 13.6836 6.36521 11.5241C7.65335 8.94568 10.3262 8.01099 10.3262 8.01099C10.3262 8.01099 11.0508 7.57587 11.9203 8.18826C12.7898 8.81676 13.4822 9.99318 12.9508 10.9601V10.9601Z"
        fill="url(#paint0_linear_337_32)"
      />
      <path
        d="M13.3212 11.3469C13.3212 11.3469 14.1746 11.8948 14.3678 12.6362C14.3678 12.6362 14.3356 12.9101 14.6737 12.6845C15.0118 12.4589 16.7186 11.3469 17.4754 11.7337C18.2322 12.1205 18.8118 13.0229 19.15 12.9746C19.4881 12.9423 19.633 13.0713 19.5203 13.2485C19.4076 13.4419 19.2788 13.5064 19.2788 13.5064C19.2788 13.5064 19.8745 13.3936 19.794 13.6192C19.7135 13.8448 19.2305 13.587 19.2305 13.587C19.2305 13.587 18.7313 13.9737 18.6991 13.5064C18.6669 13.039 17.9745 12.201 17.4754 12.1043C16.9762 12.0238 16.1873 12.3138 15.6881 12.5556C15.2051 12.7812 14.5288 13.5708 13.9169 12.8457C13.289 12.1366 13.144 11.4114 13.144 11.4114L13.3212 11.3469V11.3469Z"
        fill="black"
      />
      <path
        d="M13.8364 12.1205C13.8525 12.1527 14.8991 12.0721 15.5754 13.2486C15.5754 13.2486 15.5432 13.4581 15.3017 13.7965C15.0601 14.1349 14.5127 15.1824 14.6737 15.5208C14.8186 15.8592 15.6559 16.8584 15.6559 16.8584C15.6559 16.8584 16.2195 17.1001 16.0746 17.2935C15.9296 17.4869 15.7525 17.4869 15.7525 17.4869C15.7525 17.4869 16.2839 18.2282 15.9135 18.1315C15.5432 18.0348 15.5271 17.6642 15.5271 17.6642C15.5271 17.6642 15.0924 18.0187 15.0601 17.6642C15.0279 17.3257 15.1407 16.939 14.9957 16.7295C14.8508 16.52 14.4966 16.0849 14.3034 15.8109C14.094 15.5531 13.9813 15.4725 14.1424 15.2146C14.3195 14.9568 15.189 13.3452 15.189 13.3452C15.189 13.3452 14.2873 13.4419 13.933 12.7973L13.8364 12.1205V12.1205ZM12.9186 14.8117C12.9186 14.8117 13.7398 16.1977 13.0796 16.939C12.4195 17.6803 11.3729 18.1637 11.3246 18.5989C11.2924 19.0179 11.7593 20.0976 11.5661 20.3393C11.3729 20.581 11.1635 20.5166 11.1635 20.5166C11.1635 20.5166 11.6788 20.8067 11.3568 20.9356C11.0347 21.0645 10.6 20.9839 10.7288 20.855C10.8415 20.7261 10.9703 20.5166 10.9703 20.5166C10.9703 20.5166 10.5195 20.4038 10.7127 20.0654C10.9059 19.7269 10.9059 19.5013 10.9381 19.1629C10.9703 18.8245 10.8576 18.2765 11.1635 18.0832C11.1635 18.0832 12.7576 17.084 12.6932 16.4877C12.6288 15.8915 12.1779 15.6336 12.1779 15.6336C12.1779 15.6336 12.4678 14.6345 12.9186 14.8117Z"
        fill="black"
      />
      <path
        d="M12.9508 10.9601L7.46011 16.4555C7.46011 16.4555 7.21859 16.8745 7.87876 17.374C8.45842 17.8253 9.98808 18.4215 12.1457 17.5352C15.1889 16.2943 15.8974 13.5869 15.8974 13.5869C15.8974 13.5869 16.3321 12.8617 15.7203 11.9915C15.1084 11.1374 13.9169 10.4283 12.9508 10.9601Z"
        fill="url(#paint1_linear_337_32)"
      />
      <path
        d="M12.0169 8.59119C11.9847 8.55896 11.2118 7.70485 9.74659 9.01019C8.26523 10.2994 7.9593 13.2808 10.1008 12.3944C11.5017 11.8304 13.7881 9.79984 12.0169 8.59119V8.59119Z"
        fill="#F4C490"
        opacity="0.3"
      />
      <path
        d="M14.8831 11.4275C14.8509 11.3953 14.0297 10.5251 13.0797 11.2664C12.1297 12.0238 12.5322 14.425 14.1102 14.1671C15.1568 13.9899 16.606 12.8134 14.8831 11.4275Z"
        fill="#EBEABC"
        opacity="0.11"
      />
      <path
        d="M12.7093 8.97791C12.7093 8.97791 13.772 10.67 9.63391 14.296C9.63391 14.296 13.0958 10.9601 14.3517 10.8956L12.7093 8.97791Z"
        fill="#331A0F"
        opacity="0.47"
      />
      <path
        d="M15.6882 8.12382C15.2051 7.35028 13.1763 6.77013 13.8204 8.25274C14.4806 9.73535 15.7204 9.88039 15.8814 9.44528C16.0263 9.04239 16.0424 8.68786 15.6882 8.12382V8.12382Z"
        fill="#FFA88A"
        opacity="0.19"
      />
      <path
        d="M15.4949 8.30105C14.8992 7.33413 12.3712 6.62505 13.1763 8.4622C13.9975 10.2994 15.5272 10.4766 15.7526 9.94481C15.9619 9.39689 15.978 9.04235 15.4949 8.30105Z"
        fill="#F2AD91"
        opacity="0.09"
      />
      <path
        d="M6.36521 11.6531C7.04149 12.056 7.54064 12.475 10.5839 13.4258C13.1601 14.2315 15.2533 14.6344 15.2533 14.6344C15.2533 14.6344 11.3406 20.4843 6.79996 16.5199C4.62623 14.6022 6.36521 11.6531 6.36521 11.6531Z"
        fill="#D11317"
        opacity="0.25"
      />
      <path
        d="M10.6161 7.89819C10.6161 7.89819 13.4661 8.44611 12.3712 11.3791C12.3712 11.3791 16.1873 11.7175 14.8669 14.3121C14.8669 14.3121 14.8186 14.7794 15.2856 14.3121C16.1551 13.4419 16.2517 12.0237 15.5915 11.2502C14.9313 10.4766 13.5949 9.7998 13.5466 9.63864C13.4983 9.47749 12.0813 7.94653 11.9203 7.88207C11.7754 7.81761 10.8576 7.81761 10.6161 7.89819Z"
        fill="#331A0F"
        opacity="0.25"
      />
      <path
        d="M14.3356 10.9279C14.3356 10.9279 14.5771 11.6208 12.9025 13.329C11.5017 14.7472 8.36186 14.9728 7.26695 15.6658C6.09152 16.4071 8.36186 17.8413 9.32796 17.8897C12.7737 18.0992 14.4483 15.9881 15.0924 14.9889C15.833 13.8447 16.6059 12.3138 14.3356 10.9279V10.9279Z"
        fill="url(#paint2_linear_337_32)"
        opacity="0.81"
      />
      <path
        d="M6.20422 15.4563C6.20422 15.4563 7.02541 16.7133 8.13643 15.698C9.53727 14.4088 10.2296 13.6997 10.2296 13.6997C10.2296 13.6997 8.05592 15.9559 7.8466 16.6166C7.58897 17.4385 9.24744 17.9219 9.24744 17.9219C9.24744 17.9219 7.02541 17.9219 6.20422 15.4563V15.4563Z"
        fill="#331A0F"
        opacity="0.47"
      />
      <path
        d="M8.861 16.3265C8.861 16.3265 7.26693 16.8744 8.65168 17.5029C10.0364 18.1314 11.8076 17.5513 11.1957 16.8422C10.5517 16.1331 9.7788 16.1815 8.861 16.3265Z"
        fill="#F96A58"
        opacity="0.64"
      />
      <path
        d="M12.1297 8.34949C10.9704 8.52676 9.44072 8.97799 9.39241 10.1705C9.34411 11.1536 10.439 11.8949 11.5983 12.3139L12.9509 10.9602C13.4339 10.0738 12.9026 9.01022 12.1297 8.34949V8.34949Z"
        fill="#F4C490"
        opacity="0.17"
      />
      <path
        d="M13.4017 8.25281C13.4017 8.25281 9.47293 8.25281 9.39242 10.1705C9.29581 12.0721 13.4178 13.0391 14.1102 12.6523C14.8026 12.2816 15.4789 8.978 13.4017 8.25281V8.25281Z"
        fill="#F4C490"
        opacity="0.1"
      />
      <path
        d="M7.87879 15.5047C7.9271 15.8109 7.57286 16.0043 7.10591 15.9398C6.63896 15.8753 6.22032 15.5853 6.17201 15.2791C6.12371 14.9729 6.47795 14.7956 6.9449 14.844C7.42795 14.9084 7.84659 15.1985 7.87879 15.5047Z"
        fill="#EBE1E1"
        opacity="0.35"
      />
      <path
        d="M12.0008 8.849C12.0008 8.849 10.1491 9.10685 9.98809 10.0093C9.82707 10.9118 11.6949 11.1052 12.0491 10.8795C12.4033 10.6539 12.9347 9.0585 12.0008 8.849Z"
        fill="#FFCF9F"
        opacity="0.44"
      />
    </g>
    <defs>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint0_linear_337_32"
        x1="-3.36432"
        x2="-0.112904"
        y1="20.8014"
        y2="24.0501"
      >
        <stop stopColor="#B0191A" />
        <stop offset="0.208" stopColor="#E94E22" />
        <stop offset="0.528" stopColor="#EF7A57" />
        <stop offset="1" stopColor="#E84423" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint1_linear_337_32"
        x1="13.7831"
        x2="10.5209"
        y1="16.6517"
        y2="13.3922"
      >
        <stop stopColor="#751613" />
        <stop offset="0.209" stopColor="#BF391D" />
        <stop offset="0.528" stopColor="#EF7A57" />
        <stop offset="0.999" stopColor="#CF3320" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint2_linear_337_32"
        x1="12.4446"
        x2="11.0658"
        y1="17.7437"
        y2="14.9378"
      >
        <stop stopColor="#6C1512" />
        <stop offset="0.996" stopColor="#D42900" />
      </linearGradient>
      <clipPath id="clip0_337_32">
        <rect fill="white" height="19" transform="translate(3 2)" width="19" />
      </clipPath>
    </defs>
  </>,
  'BugIcon',
)
